import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen w-screen" }
const _hoisted_2 = { class: "bg-white rounded-md h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-10 bg-white absolute bottom-0 w-full" }, null, -1)

import TopBar from '@/components/TopBar/TopBar.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IframeDashboardLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.fullPath
      }))
    ]),
    _hoisted_3
  ]))
}
}

})